<div class="flex flex-col gap-y-15">
  @if (filesEnabled) {
    <!-- ⚠️ NO SECTION LABEL ABOVE THIS (AndyP, 2026-10-01). It used to carry a grey uppercase
         "Supporting Documents", which is now the step's own heading a line above -- the shell
         prints it from `stepHeadingOverrides`. Two identical captions stacked read as two
         sections with the first one empty. The description stays, because it says what to do,
         which the heading cannot.

         ⚠️ AND IT NO LONGER OPENS WITH "Optional:" (AndyP, 2026-10-02). The heading carries the
         qualifier now -- "Supporting Documents (Optional)" -- and saying it in both places said
         it twice a line apart, which is the same fault the removed label had. This sentence is
         for WHAT to attach; whether to attach anything is the heading's job. -->
    <div class="flex flex-col gap-y-5">
      <span class="text-sm text-gray-dark">
        Attach any documents the trade team should see with this request &mdash; statements,
        transfer paperwork, client instructions.
      </span>
    </div>

    <!-- ⚠️ THE ONE SURFACE THAT RESOLVES UNDER THE ADVISOR'S HAND, which is why it is the one
         that changes colour. Step 1 states the obligation and stays amber; Review reports it and
         says nothing once met. Here the advisor can act, so the panel answers them. -->
    @if (store.newRecipientDocumentApplies()) {
      @if (store.files().length === 0) {
        <div class="flex items-start px-10 py-8 text-xs border rounded gap-x-8 border-orange-lighter bg-orange-lightest text-orange-darker">
          <i class="material-icons" style="font-size: 1.4rem">info_outline</i>
          <span>{{ documentMissingNote() }}</span>
        </div>
      } @else {
        <!-- 🟢 Deliberately NOT a claim about what was attached. Nothing here can tell a signed
             instruction from a statement, so it reports that the request is no longer short of a
             document and leaves the judgement to the trade team. -->
        <div class="flex items-start px-10 py-8 text-xs border rounded gap-x-8 border-mint-light bg-mint-lightest text-mint-darkest">
          <i class="material-icons" style="font-size: 1.4rem">check_circle</i>
          <span>Third-party instructions attached.</span>
        </div>
      }
    }

    <!-- Drop zone -->
    <div class="flex flex-col items-center justify-center px-15 py-30 border-2 border-dashed rounded cursor-pointer"
      [ngClass]="isDragging.value ? 'border-mint-darker bg-mint-lightest' : 'border-gray-lighter bg-gray-lightest'"
      (dragover)="onDragOver($event)" (dragleave)="onDragLeave()" (drop)="onDrop($event)" (click)="browse()"
      role="button" tabindex="0" (keydown.enter)="browse()" (keydown.space)="browse()">
      <i class="material-icons text-gray" style="font-size: 3.2rem">cloud_upload</i>
      <span class="mt-5 text-base text-gray-dark">
        Drag files here or <span class="font-semibold text-mint-darker">browse</span>
      </span>
      <input #fileInput type="file" multiple class="hidden" (change)="onFilesSelected($event)" />
    </div>

    <!-- Attached files -->
    @if (store.files().length) {
      <div class="flex flex-col gap-y-5">
        <span class="text-sm font-semibold tracking-wide uppercase text-gray">
          Attached ({{ store.files().length }})
        </span>
        @for (file of store.files(); track file.name + file.size) {
          <div class="flex items-center justify-between px-15 py-8 border rounded border-gray-lighter">
            <div class="flex items-center min-w-0 gap-x-10">
              <i class="material-icons text-gray">insert_drive_file</i>
              <span class="text-base truncate text-gray-darkest" [title]="file.name">{{ file.name }}</span>
              <span class="flex-shrink-0 text-sm text-gray">{{ store.formatFileSize(file.size) }}</span>
            </div>
            <button mat-button type="button" class="icon-button is-mint is-inverted flex-shrink-0"
              [attr.aria-label]="'Remove ' + file.name" (click)="remove(file)">
              <i class="material-icons">close</i>
            </button>
          </div>
        }
      </div>
    } @else {
      <em class="text-sm text-gray-light">No files attached.</em>
    }
  }

  @if (notesEnabled) {
    <div class="flex flex-col gap-y-5" [class.mt-15]="filesEnabled">
      <label for="iasRequestNotes" class="text-sm font-semibold tracking-wide uppercase text-gray">
        Request Notes
      </label>
      <span class="text-sm text-gray-dark">
        Anything the trade team should know when working this request. Optional.
      </span>
      <textarea id="iasRequestNotes" rows="5" maxlength="4000"
        class="w-full px-15 py-8 text-base border rounded border-gray-lighter"
        placeholder="Add any context for this request&hellip;"
        [ngModel]="store.requestNotes()" (ngModelChange)="store.requestNotes.set($event)"></textarea>
      <span class="text-xs text-right text-gray">{{ store.requestNotes().length }} / 4000</span>
    </div>
  }
</div>
